<template>
	<div class="loading-screen circular-element">
		<div class="loading-progress">{{ displayProgress }}%</div>
		<h1 class="title">Loading</h1>
	</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
	name: 'LoadingScreen',
	computed: {
		...mapState({
			progress: (state) => state.global.assets.progress,
			loaded: (state) => state.global.assets.loaded,
		}),
		displayProgress() {
			return (this.progress * 100).toFixed(0);
		},
	},
	watch: {
		loaded(isLoaded, wasLoaded) {
			if (isLoaded && !wasLoaded) {
				this.complete();
			}
		},
	},
	methods: {
		complete() {
			this.$router.push("/");
		},
	},
};
</script>

<style lang="scss" scoped>
	.loading-screen {
		position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
		margin: auto;
		border-radius: 50%;
		height: 200px;
		width: 200px;
		box-sizing: initial;
		z-index: $z-top-mid;

		@include tablet {
			height: 250px;
			width: 250px;
		}

		&.circular-element:after {
			background: radial-gradient(circle at center, #5B2518 0, $alt-color-dark 60%);
		}

		&:before {
			content: '';
			position: absolute;
			background: linear-gradient(0.25turn, $alt-color-extra-light, $alt-color);
			border-radius: 50%;
			width: 100%;
			height: 100%;
			box-sizing: unset;
			z-index: -1;
		}
	}

	.host {
		width: 70%;
		max-width: 300px;
		height: auto;
	}

	.title {
		font-family: $body-font-italic;
		font-size: $font-size-lg;
		text-transform: uppercase;
		color: $text-alt;
		animation: font-grow 1.2s infinite ease-in-out both;
	}

	.loading-progress {
		font-size: $heading-size-md;
		font-family: $heading-font;
		line-height: 1;
		background: linear-gradient(to right, $alt-color, $alt-color-extra-light, $alt-color-light);
		background-clip: text;
		-webkit-text-fill-color: transparent;

		@include tablet { font-size: $heading-size-xl; }
	}

	@keyframes font-grow {
		0% { transform: scale(1.0); }
		50% { transform: scale(1.1); }
		100% { transform: scale(1.0); }
	}
</style>
